import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom";
import { Grid, Card, CardContent, Box, makeStyles, Typography, Link, useMediaQuery } from "@material-ui/core";
import { ReactComponent as Attempts } from "../../assets/images/Attempts.svg";
import { ReactComponent as BestScore } from "../../assets/images/BestScore.svg";
import { ReactComponent as CurrentScore } from "../../assets/images/CurrentScore.svg";
import { ReactComponent as TestFailedIcon } from "../../assets/images/testFailedIcon.svg";
import { ReactComponent as SuccessIcon } from "../../assets/images/enrolledIcon.svg";
import { ReactComponent as CourseCompletedIcon } from "../../assets/images/courseSuccess.svg";
import { ReactComponent as PlatinumBadge } from "../../assets/images/platinumBadge.svg";
import { ReactComponent as GoldBadge } from "../../assets/images/goldBadge.svg";
import { ReactComponent as BronzeBadge } from "../../assets/images/bronzeBadge.svg";
import { ReactComponent as PointsIcon } from "../../assets/images/pointsIcon.svg";
import { ReactComponent as LevelUpIcon } from "../../assets/images/levelUpIcon.svg";
import { ReactComponent as StarVector1 } from "../../assets/images/star-vector1.svg";
import { ReactComponent as StarVector2 } from "../../assets/images/star-vector2.svg";
import { ReactComponent as StarVector3 } from "../../assets/images/star-vector3.svg";
import { ReactComponent as CongratulationsPopper } from "../../assets/images/congratulations-popper.svg";
import { ReactComponent as PopperMobile } from "../../assets/images/popper-mobile.svg";
import { ReactComponent as PrizeMobile } from "../../assets/images/prize-mobile.svg";
import { ReactComponent as Popper } from "../../assets/images/popper.svg";
import gifImage from '../../assets/images/celebration.gif';
import "./reports.scss";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import { useSelector, useDispatch } from "react-redux";
import { useCertificateDownload } from "examsbook-react-sdk/custom-hooks";
import CommonButton from "../../constants/CommonButton";
import BadgeSharePopover from "../../components/common/BadgeSharePopover";
import { useTheme as useMuiTheme } from "@material-ui/core/styles";
import { WhatsappIcon, TwitterIcon, FacebookIcon } from "react-share";
import { courseCertificateListAction } from "examsbook-react-sdk/actions/certificateAddResponse";

const getBadgeIcon = (badgeTitle, classes, badgeUrl) => {
  if (badgeUrl && badgeUrl !== "default") {
    const imgSrc = badgeUrl.startsWith("http") ? badgeUrl : `${process.env.REACT_APP_BACKEND_URL}/badge/image/${badgeUrl}`;
    return <img src={imgSrc} alt={badgeTitle} className={classes.statIcon} style={{ objectFit: 'contain' }} />;
  }
  switch (badgeTitle) {
    case "Master":
      return <GoldBadge className={classes.statIcon} />;
    case "Knowledge Seeker":
      return <BronzeBadge className={classes.statIcon} />;
    case "Challenger":
      return <PlatinumBadge className={classes.statIcon} />;
    default:
      return <PlatinumBadge className={classes.statIcon} />;
  }
};

function ScoreCard(props) {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { courseResultData, quizAttemptsCount } = props;
  const [isUserFailed, setIsUserFailed] = useState(false);
  const [isUserPass, setIsUserPass] = useState(false);
  const [isCertificateAwarded, setIsCertificateAwarded] = useState(false);
  const [showGif, setShowGif] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [shareUrl, setShareUrl] = useState(null);
  const classes = useStyles();
  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);
  const user = useSelector((state) => state.user);
  const userName = user?.user?.name ? user?.user?.name : user?.name;
  const courseName = useSelector(state => state.filteredCourseList.courseName);
  const courseProgress = useSelector(state => state.filteredCourseList.courseProgress);
  const showEvaluationTest = useSelector(state => state.filteredCourseList.showEvaluationTest) || location?.state?.showEvaluationTest;
  const showInstructions = useSelector(state => state.filteredCourseList.showInstructions) || location?.state?.showInstructions;
  const subjectDetail = location?.state?.subjectDetail;
  const { handleDownloadCertificate } = useCertificateDownload({ userName, courseName, endDate: Date.now()});
  const quizResponseFromRedux = useSelector(state => state.selfLearningReducers.quizResponse);
  const unlockCertificateFromRedux = useSelector(state => state.selfLearningReducers.unlockCertificate);
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  
  const t = useTranslations();
  let bestScore = courseResultData?.bestScore?.reduce(
    (accumulator, currentValue) => {
      return Math.max(accumulator, currentValue);
    },
    courseResultData?.bestScore[0]
  );
  let totalMarks = courseResultData?.mark;
  let currentScore = courseResultData?.bestScore?.[courseResultData?.bestScore?.length - 1];
  let remainingAttempts = quizAttemptsCount - courseResultData?.attempted;
  const courseId = location?.state?.courseId;
  const cardData = [
    {
      title: t("Current_Score"),
      text: `${currentScore + "/" + totalMarks}`,
      imageUrl: <CurrentScore/>,
    },
    {
      title: t("attempts"),
      text: `${courseResultData?.attempted}${
        courseResultData?.quizMode === "mock-test"
          ? `/${quizAttemptsCount}`
          : ""
      }`,
      imageUrl: <Attempts/>,
    },
    {
      title: t("Best_Score"),
      text: `${bestScore + "/" + totalMarks}`,
      imageUrl: <BestScore/>,
    },
  ];

  const closeModal = () => {
    setIsUserFailed(false);
  }

  const closeSuccessModal = () => {
    setIsUserPass(false);
  }

  const closeCertificateModal = () => {
    setIsUserPass(false);
    setIsCertificateAwarded(false);
  }

  useEffect(() => {
    setIsCertificateAwarded(settingsData?.data?.[0]
      ? settingsData?.data?.[0]?.customization?.certification : false);

  }, [settingsData]);

useEffect(() => {
  const isQualified = quizResponseFromRedux?.isQualified;
  if (isQualified === false) {
    setIsUserFailed(true);
    setIsUserPass(false);
  } else if (isQualified === true) {
    setIsUserPass(true);
    setIsUserFailed(false);
  } else {
    // Fallback to score-based logic if isQualified is not available
    if (
      typeof currentScore === 'number' &&
      typeof totalMarks === 'number' &&
      typeof courseResultData?.passingPercent === 'number' &&
      totalMarks > 0 &&
      (currentScore / totalMarks) >= (courseResultData.passingPercent / 100)
    ) {
      setIsUserPass(true);
      setIsUserFailed(false);
    } else {
      setIsUserFailed(true);
      setIsUserPass(false);
    }
  }
}, [currentScore, totalMarks, courseResultData?.passingPercent, quizResponseFromRedux]);

  useEffect(() => {
    if (isUserPass) {
      setShowGif(true);
      const timer = setTimeout(() => setShowGif(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [isUserPass]);

  useEffect(() => {
    if (!isUserPass || !courseId) return;
    let attempts = 0;
    const maxAttempts = 10;
    const interval = setInterval(() => {
      dispatch(courseCertificateListAction(courseId)).then((res) => {
        const url = res?.data?.[0]?.shareUrl;
        if (url) {
          setShareUrl(url);
          clearInterval(interval);
        } else if (++attempts >= maxAttempts) {
          clearInterval(interval);
        }
      });
    }, 3000); // retry every 3 seconds
    return () => clearInterval(interval);
  }, [isUserPass, courseId, dispatch]);

  const handleShare = (platform) => {
    if (!shareUrl) return;
    const shareWindow = window.open("", "_blank");
    const text = encodeURIComponent(`🎉 I just completed "${courseName}" and earned my certificate!`);
    const encodedUrl = encodeURIComponent(shareUrl);
    const links = {
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}`,
      whatsapp: `https://api.whatsapp.com/send?text=${text}%20${shareUrl}`,
    };
    if (shareWindow) shareWindow.location.href = links[platform];
  };

  const ShareButtons = () => (
    <Box style={{ display: "flex", gap: "10px", marginTop: "16px", justifyContent: "center", opacity: shareUrl ? 1 : 0.4, pointerEvents: shareUrl ? "auto" : "none" }}>
      <Box onClick={() => handleShare("linkedin")} style={{ cursor: "pointer", borderRadius: "50%", overflow: "hidden", width: 32, height: 32 }}>
        <svg viewBox="0 0 64 64" width="32" height="32"><circle cx="32" cy="32" r="32" fill="#0077b5"/><path d="M20.4 42.6V26.2h-5.4v16.4h5.4zm-2.7-18.6c1.9 0 3-1.2 3-2.8-.1-1.6-1.2-2.8-3-2.8s-3 1.2-3 2.8c0 1.6 1.1 2.8 2.9 2.8h.1zm5.7 18.6h5.4V33.4c0-.5 0-1 .2-1.3.4-1 1.4-2 3-2 2.1 0 3 1.6 3 4v8.5h5.4V33.4c0-5.3-2.8-7.7-6.6-7.7-3.1 0-4.4 1.7-5.2 2.9v.1h-.1l.1-.1v-2.4h-5.4c.1 1.5 0 16.4 0 16.4z" fill="#fff"/></svg>
      </Box>
      <Box onClick={() => handleShare("whatsapp")} style={{ cursor: "pointer", borderRadius: "50%", overflow: "hidden", width: 32, height: 32 }}><WhatsappIcon size={32} round /></Box>
      <Box onClick={() => handleShare("twitter")} style={{ cursor: "pointer", borderRadius: "50%", overflow: "hidden", width: 32, height: 32 }}><TwitterIcon size={32} round /></Box>
      <Box onClick={() => handleShare("facebook")} style={{ cursor: "pointer", borderRadius: "50%", overflow: "hidden", width: 32, height: 32 }}><FacebookIcon size={32} round /></Box>
    </Box>
  );

  const retakeTest = () => {
    history.push({
      pathname: `/course/${courseId}`,
      state: {
        courseId: courseId,
        subjectId: '',
        topicId: '',
        subjectDetail: subjectDetail,
        subjectName: '',
        topicName: '',
        courseName: courseName,
        activeTab: 2,
        reset: true,
        courseProgress: courseProgress,
        showEvaluationTest: showEvaluationTest,
        showInstructions: showInstructions
      }
    });
  };

  const DownloadCertificate = () => {
    handleDownloadCertificate(courseName, Date.now())
    setTimeout(() => {
      closeCertificateModal();
    }, 1000);
  }

  const EvaluationTestSuccessModal = ({ showModal, closeModal }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={closeModal}>
        <Box className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.headingModal}>
            {showGif && (
              <Box className={classes.gifOverlay}>
                <img src={gifImage} alt="Celebration" className={classes.gifImage} />
              </Box>
            )}
            <CourseCompletedIcon className={classes.icon} />
            <Box className={classes.starVectorBox}>
              <StarVector1 className={classes.starVector1}/>
              <StarVector2 className={classes.starVector2}/>
              <StarVector3 className={classes.starVector3}/>
            </Box>
            <Typography variant="h2" className={classes.modalHeading}>
              {t('Congratulations!')}
            </Typography>
            <Typography variant="inherit" className={classes.modalSubtext}>
              {t('You successfully passed the')} <strong>{courseName}</strong> {t('Course evaluation')}
            </Typography>
            <CommonButton onClick={closeSuccessModal} classStyleHeading={classes.okBtn} title={t("View Result")} />
            <Link component="button" underline="none" className={classes.goToCoursesLink} onClick={() => history.push('/courses')}>
              {t('Back To Course')}
            </Link>
          </Box>
        </Box>
      </Box>
    )
  }

  const EvaluationTestCertificateModal = ({ showModal, closeModal }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={closeModal}>
        <Box className={classes.modalContent} style={{width: isMobile ? '' : '540px'}} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.headingModal}>
            {showGif && (
              <Box className={classes.gifOverlay}>
                <img src={gifImage} alt="Celebration" className={classes.gifImage} />
              </Box>
            )}
            <SuccessIcon className={classes.icon} />
            <Box className={classes.starVectorBox}>
              <StarVector1 className={classes.starVector1}/>
              <StarVector2 className={classes.starVector2}/>
              <StarVector3 className={classes.starVector3}/>
            </Box>
            <Typography variant="h2" className={classes.modalHeading}>
              {t("Passed & Certified")}
            </Typography>
            <Typography variant="inherit" className={classes.modalSubtext}>
              {t("Your hard work has paid off")} <strong>{courseName}</strong> {t("Course Congratulations")}
            </Typography>
            <CommonButton classStyleHeading={classes.okBtn} title={t("Download Cerificate")} onClick={DownloadCertificate} />
            <ShareButtons />
            <Link component="button" underline="none" className={classes.goToCoursesLink} onClick={closeCertificateModal}>
              {t("View Result")}
            </Link>
          </Box>
        </Box>
      </Box>
    )
  }

  const EvaluationTestCertificateGamificationModal = ({ showModal, closeModal }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={closeModal}>
        <Box className={classes.modalContent} onClick={(e) => e.stopPropagation()}>
          <CongratulationsPopper className={classes.bgSvg} />
          <PopperMobile className={classes.mobileSvg}/>
          <Box className={classes.innerWrapper}>
            {showGif && (
              <Box className={classes.gifOverlay}>
                <img src={gifImage} alt="Celebration" className={classes.gifImage} />
              </Box>
            )}
            {/* LEFT SIDE */}
            <Box className={classes.leftBox}>
              <Popper className={classes.popperIcon}/>
              <PrizeMobile className={classes.prizeMobileIcon}/>
              <Typography variant="h2" className={classes.congratsHeading}>
                {t('Congratulations!')}
              </Typography>
              <Typography variant="inherit" className={classes.congratsText}>
                {t('successfully passed the evaluation test')}
              </Typography>
            </Box>

            {/* RIGHT SIDE */}
            <Box className={classes.rightBox}>
              <Box className={classes.statsWrapper}>
                {quizResponseFromRedux?.achievedLevels?.[0]?.badgeAward?.badgeToggle && quizResponseFromRedux?.newBadgesAwarded?.[0]?.title && <Box className={classes.statGroup}>
                  <Box className={classes.statBox}>
                    {getBadgeIcon(quizResponseFromRedux?.newBadgesAwarded?.[0]?.title, classes, quizResponseFromRedux?.newBadgesAwarded?.[0]?.badgeUrl)}
                    <Typography className={classes.statValue}>{quizResponseFromRedux?.newBadgesAwarded?.[0]?.title}</Typography>
                  </Box>
                  <Typography className={classes.statLabel}>{t('Badge')}</Typography>
                </Box>}
                {quizResponseFromRedux?.achievedLevels?.[0]?.pointAward?.pointToggle && quizResponseFromRedux?.pointsEarned > 0 && <Box className={classes.statGroup}>
                  <Box className={classes.statBox}>
                    <PointsIcon className={classes.statIcon} />
                    <Typography className={classes.statValue}>{quizResponseFromRedux?.pointsEarned}</Typography>
                  </Box>
                  <Typography className={classes.statLabel}>{t('Points')}</Typography>
                </Box>}
                {quizResponseFromRedux?.achievedLevels?.[0]?.isLevelStatusActive && quizResponseFromRedux?.achievedLevels?.[0]?.criteriaTitle && <Box className={classes.statGroup}>
                  <Box className={classes.statBox}>
                    <LevelUpIcon className={classes.statIcon} />
                    <Typography className={classes.statValue}>{quizResponseFromRedux?.achievedLevels?.[0]?.criteriaTitle}</Typography>
                  </Box>
                  <Typography className={classes.statLabel}>{t('Level')}</Typography>
                </Box>}
              </Box>
              {quizResponseFromRedux?.achievedLevels?.[0]?.badgeAward?.badgeToggle && quizResponseFromRedux?.newBadgesAwarded?.[0]?.title && (
                <Box style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                  <BadgeSharePopover badge={quizResponseFromRedux?.newBadgesAwarded?.[0]} />
                </Box>
              )}

              <CommonButton
                classStyleHeading={classes.okBtnCertificate}
                title={t("Download Certificate")}
                onClick={DownloadCertificate}
              />
              <ShareButtons />
              <Link
                component="button"
                underline="none"
                className={classes.goToCoursesLinkCertificate}
                onClick={()=>{closeModal(); history.push('/courses')}}
              >
                {t("Explore More Courses")}
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }

  const EvaluationTestFailedModal = ({ showModal, closeModal }) => {
    return (
      <Box className={classes.modalBg + ` ${showModal ? "show" : ""}`} onClick={closeModal}>
        <Box className={classes.modalContent} style={{width: isMobile ? '' : '490px'}} onClick={(e) => e.stopPropagation()}>
          <Box className={classes.headingModal}>
            <TestFailedIcon className={classes.icon} />
            <Box className={classes.starVectorBox}>
              <StarVector1 className={classes.starVector1}/>
              <StarVector2 className={classes.starVector2}/>
              <StarVector3 className={classes.starVector3}/>
            </Box>
            <Typography variant="h2" className={classes.modalHeading}>
              {t("Almost There")}
            </Typography>
            <Typography variant="inherit" className={classes.modalSubtext}>
              {t("Earn your certificate")}
            </Typography>
            <Typography variant="inherit" className={classes.modaltext}>
              {remainingAttempts}  {t("Attempts Left")}
            </Typography>
            <CommonButton onClick={retakeTest} classStyleHeading={classes.okBtn} title={t("Retake Test")}/>
            <Link component="button" underline="none" className={classes.goToCoursesLink} onClick={closeModal}>
               {t("View Result")}
            </Link>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Grid
      container
      spacing={2}
      className="custom-grid"
      style={{ paddingLeft: "15px" }}
    >
      {cardData.map((card, index) => (
        <Grid item xs={12} sm={4} md={4} key={index}>
          <Card className="card-detail" style={{ backgroundColor: "#ECEFF1" }}>
            <Grid container className="card-data">
              <Grid item xs={10}>
                <CardContent className="card-content">
                  <div className="custom-subtitle">{card.text}</div>
                  <div className="heading-title card-title">{card.title}</div>
                </CardContent>
              </Grid>
              <Grid item xs={2}>
                <span className="score-icons">
                  {card.imageUrl}
                </span>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      ))}
      {isUserFailed && 
        <EvaluationTestFailedModal showModal={isUserFailed} closeModal={closeModal}/>
      }

      {isUserPass && !settingsData?.data?.[0]?.gamification?.enabled && !isCertificateAwarded &&
        <EvaluationTestSuccessModal showModal={isUserPass} closeModal={closeSuccessModal}/>
      }

      {isCertificateAwarded && isUserPass && !isUserFailed && unlockCertificateFromRedux && !location?.state?.redirectFromViewResult && (
        settingsData?.data?.[0]?.gamification?.enabled ? (
          <EvaluationTestCertificateGamificationModal showModal={isUserPass} closeModal={closeCertificateModal} />
        ) : (
          <EvaluationTestCertificateModal showModal={isUserPass} closeModal={closeCertificateModal} />
        )
      )}
    </Grid>
  );
}

const useStyles = makeStyles(theme => ({
    modalBg: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100% !important',
        zIndex: '999999',
        position: 'fixed',
        background: '#00000080'
    },
    bgSvg: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 0,
      background: '#FBFBFB',
      borderRadius: '25px',
      '@media (max-width:959px)': {
        display: 'none'
      },
    },
    mobileSvg: {
      position: 'absolute',
      top: '0px',
      margin: '1px',
      left: '4px',
      zIndex: '1',
      background: '#FBFBFB',
      height: '-webkit-fill-available',
      width: 'auto',
      borderRadius: '25px',
      '@media (min-width:959px)': {
        display: 'none'
      },
    },
    popperIcon: {
      position: 'absolute',
      top: '70px',
      '@media (max-width:959px)': {
        display: 'none'
      },
    },
    modalContent: {
        backgroundColor: '#fff',
        position: 'absolute',
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: '16px',
        borderRadius: '25px',
        width: '700px',
        '@media (max-width:959px)': {
          width: '350px',
          background: '#FBFBFB'
        },
        '@media (max-width:439px)': {
          width: '320px',
        }
    },
    headingModal: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        borderRadius: "25px",
        padding: '40px 50px',
      '@media (max-width:439px)': {
        padding: '30px',
      }
    },
    gifOverlay: {
        position: 'absolute',
        width: '100%',
        left: '0px',
        top: '0px',
        height: '100%',
        '@media (max-width:959px)': {
          height: 'unset',
          zIndex: '1',
          background: '#FBFBFB'
        }
      },
      prizeMobileIcon: {
        width: 'auto',
        '@media (min-width:960px)': {
          display: 'none'
        }
      },
    gifImage: {
      width:"100%",
      '@media (max-width:959px)': {
        position: 'absolute',
      },
    },
    icon: {
    '@media (max-width:959px)': {
      width: '48px',
      height: '48px',
    },
    '@media (max-width:439px)': {
      width: '34px',
      height: '34px',
    }},
    modalHeading: {
        textAlign: 'center',
        fontWeight: 600,
        color: '#000000',
        fontSize: '20px',
        marginTop: '30px',
        '@media (max-width:959px)': {
          marginTop: '20px',
        },
        '@media (max-width:439px)': {
          fontSize: '14px',
          marginTop: '10px',
        }
    },
    modalSubtext: {
        textAlign: 'center',
        fontWeight: '400',
        color: '#374151',
        fontSize: '14px',
        marginTop: '20px',
        '@media (max-width:439px)': {
          fontSize: '11px',
          marginTop: '10px',
        }
    },
    modaltext: {
        fontWeight: '600',
        color: '#717171',
        fontSize: '12px',
        marginTop: '30px',
        '@media (max-width:959px)': {
          marginTop: '20px',
        },
        '@media (max-width:439px)': {
          fontSize: '9px',
          marginTop: '10px',
        }
    },
    okBtn: {
        fontWeight: '500',
        borderRadius: '8px',
        color: 'white',
        cursor: 'pointer',
        textTransform: 'capitalize',
        backgroundColor: '#0C3450',
        '&:hover': {
            backgroundColor: '#0C3450 !important',
        },
        fontSize: "12px",
        marginTop: '20px',
        padding: "10px 30px",
        '@media (max-width:439px)': {
          fontSize: '11px',
          marginTop: '10px',
          padding: "8px 20px",
        }
    },
    goToCoursesLink: {
        color: '#0C3450',
        fontWeight: 600,
        fontSize: '12px',
        marginTop: '20px',
        '@media (max-width:439px)': {
          fontSize: '11px',
          marginTop: '10px',
        }
    },
  innerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: "25px",
    padding: '40px 50px',
    '@media (max-width:959px)': {
      width: '100%',
      flexDirection: 'column',
      gap: '20px'
    }
  },
  leftBox: {
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
    zIndex: 1,
    '@media (max-width:959px)': {
      width: '100%',
      marginTop: '0px',
      textAlign:'center'
    }
  },
  rightBox: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '40px',
    zIndex: 1,
    '@media (max-width:959px)': {
      width: '100%',
      marginTop: '0px',
    }
  },
  congratsHeading: {
        textAlign: 'left',
        fontWeight: 600,
        color: '#000000',
        fontSize: '20px',
        marginTop: '30px',
        '@media (max-width:959px)': {
        textAlign: 'center',
          marginTop: '20px',
        },
        '@media (max-width:439px)': {
          fontSize: '14px',
          marginTop: '10px',
        }
    },
  congratsText: {
    fontWeight: '400',
    color: '#374151',
    fontSize: '14px',
    marginTop: '20px',
    textAlign: 'left',
    '@media (max-width:959px)': {
      fontSize: '12px',
      marginTop: '10px',
      textAlign: 'center',
    },
    '@media (max-width:439px)': {
      fontSize: '9px',
    }
  },
  statsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '30px',
    gap: '25px',
    width: '100%',
    '@media (max-width:959px)': {
      gap: '12px',
      marginTop: '0px',
    }
  },
  statGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  statBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px solid #DBDBDB',
    borderRadius: '6px',
    padding: '10px',
    minWidth: '80px',
    textAlign: 'center',
    '@media (max-width:439px)': {
      width: '55px',
      padding: '5px',
    }
  },
  statIcon: {
    width: '38px',
    height: '38px',
    '@media (max-width:439px)': {
      width: '25px',
      height: '25px',
    }
  },
  statValue: {
    marginTop: '8px',
    fontSize: '9px',
    textAlign: 'center',
    fontWeight: 500,
    color: '#000000',
    '@media (max-width:439px)': {
      fontSize: '6px',
    }
  },
  statLabel: {
    fontSize: '10px',
    fontWeight: 400,
    color: '#000000',
    marginTop: '10px',
    '@media (max-width:439px)': {
      fontSize: '8px',
    }
  },
  okBtnCertificate: {
        fontWeight: '500',
        borderRadius: '8px',
        color: 'white',
        cursor: 'pointer',
        textTransform: 'capitalize',
        backgroundColor: '#0C3450',
        '&:hover': {
            backgroundColor: '#0C3450 !important',
        },
        fontSize: "12px",
        marginTop: '20px',
        padding: "10px 30px",
        '@media (max-width:959px)': {
          fontSize: "10px",
          padding: "8px 20px",
        },
        '@media (max-width:439px)': {
          fontSize: '9px',
          marginTop: '10px',
        }
    },
    goToCoursesLinkCertificate: {
        color: '#0C3450',
        fontWeight: 600,
        fontSize: '12px',
        marginTop: '20px',
        '@media (max-width:959px)': {
          fontSize: '11px',
          marginTop: '10px',
        },
    },
  starVectorBox: {
    display: 'flex',
    position: 'fixed',
    top: '20px',
    right: '30px',
  },
  starVector1: {
    marginTop: '10px',
    zIndex: 1,
    marginRight: '-8px'
  },
  starVector2: {
    marginTop: "12px"
  },
  starVector3: {
    marginLeft: "10px"
  }
}));

export default ScoreCard;
